import React from 'react';
import './Projects.css';
import creative from '../images/creative.png';
import tour from '../images/tour.png';
import volunteer from '../images/volunteer.png';
import emaJhon from '../images/emaJhon.png';
import school from '../images/school.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

const Projects = () => {


    return (
        <section className="projects" id="projects">
            <div className="max-width">
                <h2 className="title">My Recent works</h2>
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <figure>
                                <img className="card-img-top" src={creative} alt="" />
                            </figure>
                            <div className="card-body">
                                <h5 className="card-title">Creative Agency</h5>
                                <p className="card-text">
                                    This is a single page service provider web application.
                                    Customer can order a services if he/she is logged in using google authentication.
                                    The administrator can add and delete the services and change the customer's order status.
                                    After taking service customer can review.
                                </p>
                                <div className="technology mb-4">
                                    <span>React</span>
                                    <span>Express</span>
                                    <span>Mongodb</span>
                                    <span>Firebase</span>
                                    <span>Bootstrap</span>
                                    <span>HTML</span>
                                    <span>CSS</span>
                                    <span>Heroku</span>
                                </div>
                            </div>
                            <div className="card-footer">
                                <a href="https://github.com/Farhad16/creative-agency" target="_blank" className="site-link"><FontAwesomeIcon icon={faGithub} ></FontAwesomeIcon></a>
                                <a href="https://creative-agency-pro.firebaseapp.com/" target="_blank" className="site-link"><FontAwesomeIcon icon={faExternalLinkAlt} ></FontAwesomeIcon></a>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <figure>
                                <img className="card-img-top" src={volunteer} alt="" />
                            </figure>
                            <div className="card-body">
                                <h5 className="card-title">Join As a Volunteer</h5>
                                <p className="card-text">
                                    This is a web application for registering as a volunteer.
                                    To register as a volunteer you must logged in.
                                    After logged in it will take you register page then you have to fill some essential information and confirm registration.
                                    Administrator can delete a registered user and add events.
                                </p>
                                <div className="technology mb-4">
                                    <span>React</span>
                                    <span>Express</span>
                                    <span>Mongodb</span>
                                    <span>Firebase</span>
                                    <span>Bootstrap</span>
                                    <span>HTML</span>
                                    <span>CSS</span>
                                    <span>Heroku</span>
                                </div>
                            </div>
                            <div className="card-footer">
                                <a href="https://github.com/Farhad16/volunteer-client-side" target="_blank" className="site-link"><FontAwesomeIcon icon={faGithub} ></FontAwesomeIcon></a>
                                <a href="https://volunteer-social.firebaseapp.com/" target="_blank" className="site-link"><FontAwesomeIcon icon={faExternalLinkAlt} ></FontAwesomeIcon></a>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <figure>
                                <img className="card-img-top" src={emaJhon} alt="" />
                            </figure>
                            <div className="card-body">
                                <h5 className="card-title">Amazon Clone</h5>
                                <p className="card-text">
                                    This is a simple e-commerce web application where
                                    user can purchase products.
                                    They can review their cart. Also can remove product.
                                    To proceed order user must logged in and provides some information.
                                    Here I use a payment system which is stripe payment gateway.
                                </p>
                                <div className="technology mb-4">
                                    <span>React</span>
                                    <span>Express</span>
                                    <span>Mongodb</span>
                                    <span>Firebase</span>
                                    <span>Bootstrap</span>
                                    <span>HTML</span>
                                    <span>CSS</span>
                                    <span>Heroku</span>
                                </div>
                            </div>
                            <div className="card-footer">
                                <a href="https://github.com/Farhad16/ema-john-simple" target="_blank" className="site-link"><FontAwesomeIcon icon={faGithub} ></FontAwesomeIcon></a>
                                <a href="https://ema-john16.web.app/" target="_blank" className="site-link"><FontAwesomeIcon icon={faExternalLinkAlt} ></FontAwesomeIcon></a>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <figure>
                                <img className="card-img-top" src={tour} alt="" />
                            </figure>
                            <div className="card-body">
                                <h5 className="card-title">Travel booking</h5>
                                <p className="card-text">
                                    Travel booking is also a single page web application
                                    where user can book tour place and see the restaurant in the selected area.
                                    For booking a restuarant or place user have to be login with google account.
                                    Here I also use a dynamic google map and a marker will show user's selected area.
                                </p>
                                <div className="technology mb-4">
                                    <span>React</span>
                                    <span>Firebase</span>
                                    <span>Bootstrap</span>
                                    <span>HTML</span>
                                    <span>CSS</span>
                                    <span>Google Map</span>
                                </div>
                            </div>
                            <div className="card-footer">
                                <a href="https://github.com/Farhad16/travel-tour-trip" target="_blank" className="site-link"><FontAwesomeIcon icon={faGithub} ></FontAwesomeIcon></a>
                                <a href="https://travel-tour-trip.web.app/" target="_blank" className="site-link"><FontAwesomeIcon icon={faExternalLinkAlt} ></FontAwesomeIcon></a>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <figure>
                                <img className="card-img-top" src={school} alt="" />
                            </figure>
                            <div className="card-body">
                                <h5 className="card-title">Online School</h5>
                                <p className="card-text">
                                    This is a bootstrap base static web site. Generally this a online school and book selling site.
                                    <br />Also the details of the school is available in the site page.
                                    <br />Ones can know about the courses and books that the school has.
                                </p>
                                <div className="technology mb-4">
                                    <span>Bootstrap</span><br />
                                    <span>HTML</span>
                                    <span>CSS</span>
                                </div>
                            </div>
                            <div className="card-footer">
                                <a href="https://github.com/Farhad16/e-school" target="_blank" className="site-link"><FontAwesomeIcon icon={faGithub} ></FontAwesomeIcon></a>
                                <a href="https://farhad16.github.io/e-school/" target="_blank" className="site-link"><FontAwesomeIcon icon={faExternalLinkAlt} ></FontAwesomeIcon></a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Projects;